/**
 * Withdrawal processing claim — display and lease rules.
 * The database claim is atomic. These helpers only decide what the
 * Withdrawal Management screen should show, and they never include an email.
 */

export const CLAIM_TTL_MS = 10 * 60 * 1000

function cleanPersonName(value) {
  const text = String(value || '').replace(/\s+/g, ' ').trim()
  if (!text || text.includes('@') || text.length > 80) return ''
  return text
}

export function adminDisplayName({ fullName, username } = {}) {
  return cleanPersonName(fullName) || cleanPersonName(username) || 'Admin'
}

export function claimIsLive(expiresAt, now = Date.now()) {
  if (!expiresAt) return false
  const time = new Date(expiresAt).getTime()
  return Number.isFinite(time) && time > now
}

export function busyAdminName(row, now = Date.now()) {
  if (!row || row.status !== 'pending') return null
  if (!claimIsLive(row.processing_claim_expires_at, now)) return null
  return cleanPersonName(row.processing_admin_name) || null
}

export function claimHeldByOther(row, adminId, now = Date.now()) {
  if (!busyAdminName(row, now)) return false
  if (!adminId) return true
  return String(row.processing_admin_user_id || '') !== String(adminId)
}

function createdAtMillis(row) {
  const time = new Date(row?.created_at || 0).getTime()
  return Number.isFinite(time) ? time : 0
}

function claimedAtMillis(row) {
  const time = new Date(row?.processing_claimed_at || 0).getTime()
  return Number.isFinite(time) ? time : 0
}

/** Free rows stay in newest-first order. A live claim moves that row to the bottom. */
export function compareWithdrawalQueue(a, b, now = Date.now()) {
  const aBusy = busyAdminName(a, now) ? 1 : 0
  const bBusy = busyAdminName(b, now) ? 1 : 0
  if (aBusy !== bBusy) return aBusy - bBusy
  if (aBusy) return claimedAtMillis(a) - claimedAtMillis(b)
  return createdAtMillis(b) - createdAtMillis(a)
}
